export const GLUCOSE_ITEMS = [
	{ value: 'mgdl', title: 'mg/dl' },
	{ value: 'mmol', title: 'mmol/L' },
]

export const UNITS_ITEMS = [
	{ value: 'lb/fit/inch', title: 'US (lb/ft)' },
	{ value: 'kg/cm', title: 'Metric (kg/cm)' },
]

export const CURBS_ITEMS = [
	{ value: 'imperial', title: 'Oz' },
	{ value: 'metric', title: 'Grams' },
]

export const DATE_FORMAT_ITEMS = [
	{ value: 'MM/DD/YY', title: 'MM/DD/YYYY' },
	{ value: 'DD/MM/YY', title: 'DD/MM/YYYY' },
]

export const TEMPERATURE_ITEMS = [
	{ value: 'fahrenheit', title: 'Fahrenheit' },
	{ value: 'celsius', title: 'Celsius' },
]
